import type { SxProps, Theme } from '@mui/material/styles';
import { components as dsComponents } from '@openx/design-system/theme/components.ts';
import { text as dsText } from '@openx/design-system/theme/tokens/index.ts';

const dsOutlinedInput = dsComponents.MuiOutlinedInput;
const dsOutlinedInputRoot = (dsOutlinedInput?.styleOverrides?.root ?? {}) as Record<string, object>;

// DS `MuiOutlinedInput` for the scoped themes of migrated inputs. The scoped theme keeps the core palette, so text
// colours are pinned to DS tokens here.
export const designSystemOutlinedInput = {
  ...dsOutlinedInput,
  styleOverrides: {
    ...dsOutlinedInput?.styleOverrides,
    root: {
      ...dsOutlinedInputRoot,
      color: dsText.primary,
      '&.Mui-disabled': {
        ...dsOutlinedInputRoot['&.Mui-disabled'],
        color: dsText.disabled,
        '& .MuiOutlinedInput-input.Mui-disabled': { WebkitTextFillColor: dsText.disabled },
      },
    },
  },
} as NonNullable<Theme['components']>['MuiOutlinedInput'];

// DS label-tab spacing for the DS TextField root: the field's `margin` goes above the tab instead of between the tab
// and the input.
export const labelTabMarginSx: SxProps<Theme> = {
  '& > *:has(> .OxField-labelTab) + .MuiFormControl-marginDense, & > *:has(> .OxField-labelTab) + .MuiFormControl-marginNormal':
    { marginTop: 0 },
  '& > *:has(> .OxField-labelTab):has(+ .MuiFormControl-marginDense)': { marginTop: '8px' },
  '& > *:has(> .OxField-labelTab):has(+ .MuiFormControl-marginNormal)': { marginTop: '16px' },
};
